<template>
	<div class="basis-page-cls">
		<table-search-index :defaultQuery="listQuery" :filterHeader="filterHeader" @filterSearch="filterSearch"></table-search-index>
		<section class="basis-cls_table">
		    <div class="header">
		        <span class="title el-icon-document"> 数据列表</span>
		     </div>
		    <div class="table">
				<table-pagination
					v-loading="loading"
		            :data="list"
		            :column="column"/>
		    </div>
		</section>
	</div>
</template>

<script>
	import {formatDate } from 'utils/index';
	export default {
		data() {
			return {
				filterHeader: [
					{label: '查询日期', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择'}
				],
				listQuery:{
					brandIdentify:'',
					pageNumber:1,
					pageSize:10,
					date:'',
					startTime:'',
					endTime:''
				},
				list:[],
				total:0,
				column:[
					{
					    label: '序号',
					    width: 80,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},
					{ label: '日期', prop: 'date' },
					{ label: '任务数量', prop: 'rwCount' },
					{ label: '分配数量', prop: 'fpCount' },
					{ label: '外呼处理数', prop: 'whclsCount' },
					{ label: '接通数', prop: 'jtCount' },
					{ label: '有意向数', prop: 'yyxsCount' },
					{ label: '已下发门店数', prop: 'yxfmdCount' },
					{ label: '已分配孵化团队数', prop: 'yfhtdCount' },
					{ label: '拒绝数', prop: 'jjCount' },
					{ label: '再联系数', prop: 'zlxCount' },
					{ label: '未接通原因1数(一呼未接通数)', prop: 'notConnected1' },
					{ label: '未接通原因2数(二呼未接通数)', prop: 'notConnected2' },
					{ label: '未接通原因3数(三呼未接通数)', prop: 'notConnected3' },
					  
				],
				loading:false,
			}
		},
		methods: {
			filterSearch(){
				this.listQuery.pageNumber = 1;
				if(this.listQuery.date && this.listQuery.date.length > 0){
					this.listQuery.startTime = formatDate(this.listQuery.date[0], 'YYYY-MM-DD');
					this.listQuery.endTime = formatDate(this.listQuery.date[1], 'YYYY-MM-DD');
				}else {
					this.listQuery.startTime = '';
					this.listQuery.endTime = ''
				}
				this.getList();
			},
			getList() {
				this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
				let params = JSON.parse(JSON.stringify(this.listQuery));
				delete params.date;
				this.loading = true;
				this.$api.getTaskBreathTaskAnalyese(params).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.data;
					this.total = Number(res.total);
				}).catch(err => {
					this.loading = false;
				})
			}
		},
		created(){
			this.getList();
		}
	}
</script>

<style>
</style>